<script>
export default {
	name: 'IconSvgWebp',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_12_399)">
				<path
					d="M13.3995 4.104C12.9347 4.10333 12.4892 3.92198 12.1606 3.5997C11.8321 3.27743 11.6473 2.84055 11.6468 2.3849V0H3.81494C3.20829 0 2.6265 0.236249 2.19754 0.656782C1.76858 1.07731 1.52759 1.64769 1.52759 2.24241V15.7602C1.52849 16.3543 1.76987 16.9238 2.19874 17.3436C2.6276 17.7635 3.20888 17.9993 3.81494 17.9992H13.2168C13.8228 17.9993 14.4041 17.7635 14.833 17.3436C15.2618 16.9238 15.5032 16.3543 15.5041 15.7602V4.104H13.3995Z"
					:fill="color" />
				<path
					d="M15.5042 4.104H13.3995C12.9348 4.10333 12.4892 3.92198 12.1606 3.5997C11.8321 3.27743 11.6473 2.84055 11.6469 2.3849V0L15.5042 4.104Z"
					fill="#FFBC00" />
				<path
					d="M17.1624 14.2169H6.53404C5.78012 14.2169 5.16895 14.8161 5.16895 15.5552V18.6617C5.16895 19.4008 5.78012 20 6.53404 20H17.1624C17.9164 20 18.5275 19.4008 18.5275 18.6617V15.5552C18.5275 14.8161 17.9164 14.2169 17.1624 14.2169Z"
					fill="#FFBC00" />
				<path
					d="M10.889 15.8556L10.2779 18.3614H9.51295L9.10496 16.6848L8.69274 18.3614H7.92778L7.31665 15.8556H7.98897L8.3179 17.6706L8.76668 15.8556H9.44665L9.89543 17.6706L10.2278 15.8556H10.889Z"
					fill="#F3F3F6" />
				<path
					d="M11.7574 16.3373V16.8614H12.6041V17.3189H11.7574V17.8756H12.7108V18.3614H11.1508V15.8556H12.7108V16.3373H11.7574Z"
					fill="#F3F3F6" />
				<path
					d="M14.9549 17.2939C15.0428 17.4034 15.0896 17.5402 15.0874 17.6806C15.0917 17.7747 15.0747 17.8685 15.0376 17.9551C15.0005 18.0417 14.9443 18.1188 14.8732 18.1806C14.7299 18.3006 14.5249 18.3614 14.2582 18.3614H13.0916V15.8556H14.229C14.484 15.8556 14.6813 15.9111 14.8207 16.0223C14.8904 16.0794 14.9457 16.1522 14.982 16.2348C15.0184 16.3173 15.0348 16.4072 15.0299 16.4973C15.0351 16.6332 14.9927 16.7668 14.9099 16.8748C14.8306 16.9749 14.7189 17.0444 14.5941 17.0714C14.7363 17.1021 14.8637 17.1806 14.9549 17.2939ZM13.6982 16.8831H14.0949C14.3054 16.8831 14.4107 16.7931 14.4107 16.6131C14.4107 16.4331 14.3032 16.3434 14.0882 16.3439H13.6982V16.8831ZM14.4674 17.5956C14.4693 17.5561 14.4624 17.5166 14.4471 17.4802C14.4318 17.4437 14.4086 17.4111 14.379 17.3848C14.3076 17.33 14.2189 17.3028 14.129 17.3081H13.6999V17.8714H14.1324C14.3557 17.8714 14.4674 17.7795 14.4674 17.5956Z"
					fill="#F3F3F6" />
				<path
					d="M16.0869 17.4822V18.3613H15.469V15.8556H16.4669C16.7703 15.8556 17.0024 15.9289 17.1613 16.0773C17.2418 16.1546 17.3047 16.2477 17.3459 16.3505C17.387 16.4534 17.4055 16.5636 17.4002 16.6739C17.4029 16.8196 17.3659 16.9634 17.2931 17.0905C17.2189 17.2148 17.1089 17.3148 16.9769 17.378C16.8176 17.4515 16.6429 17.4871 16.4669 17.4822H16.0869ZM16.7737 16.6739C16.7737 16.4545 16.6496 16.3434 16.4014 16.3406H16.0869V16.9922H16.4014C16.6496 16.995 16.7737 16.8889 16.7737 16.6739Z"
					fill="#F3F3F6" />
				<path d="M7.1005 17.7556V18.3614H6.46045V17.7556H7.1005Z" fill="#F3F3F6" />
				<path
					d="M8.51469 12.7095C8.22883 12.7091 7.95482 12.5975 7.75277 12.3993C7.55071 12.201 7.43711 11.9323 7.43689 11.6521V10.5946H9.59334V11.6521C9.59311 11.9324 9.47939 12.2013 9.27716 12.3996C9.07492 12.5978 8.8007 12.7093 8.51469 12.7095ZM7.98854 11.1354V11.6521C7.98854 11.7889 8.04394 11.9202 8.14259 12.0171C8.24124 12.114 8.37507 12.1685 8.51469 12.1687C8.65439 12.1685 8.7883 12.114 8.88708 12.0171C8.98587 11.9203 9.04146 11.789 9.04168 11.6521V11.1354H7.98854Z"
					fill="#FFBC00" />
				<path d="M7.43577 10.5955H8.51697V9.5355H7.43577V10.5955Z" fill="#FFBC00" />
				<path d="M8.51463 9.53625H9.59583V8.4763H8.51463V9.53625Z" fill="#FFBC00" />
				<path d="M7.43577 8.47717H8.51697V7.41722H7.43577V8.47717Z" fill="#FFBC00" />
				<path d="M8.51463 7.41797H9.59583V6.35802H8.51463V7.41797Z" fill="#FFBC00" />
			</g>
			<defs>
				<clipPath id="clip0_12_399">
					<rect width="20" height="20" fill="white" transform="translate(0.0275879)" />
				</clipPath>
			</defs>
		</svg>

	</div>
</template>

<style scoped>

</style>